import React from 'react';
import { AdditionalInfo, TileTitle, TileWrapper } from './LocationInfo.styles';

type OwnProps = {
  info: React.ReactNode;
  infoLink: string;
  infoLinkHref: string;
  title: string;
};

export default function LocationTile({
  info,
  infoLink,
  infoLinkHref,
  title
}: OwnProps) {
  return (
    <TileWrapper key={title}>
      <TileTitle>{title}</TileTitle>
      <AdditionalInfo>
        {info}
        {infoLink && infoLinkHref && (
          <div>
            <a
              href={infoLinkHref}
              target={infoLinkHref.startsWith('#') ? '_self' : '_none'}
              className="text-blue-2"
              data-analytics-id="Location Tile"
              data-testid="location-tile-link"
            >
              {infoLink}
            </a>
          </div>
        )}
      </AdditionalInfo>
    </TileWrapper>
  );
}
